<template>
  <div class="contribuinte-vinculo">
    <PessoaCadastro />
    <Dialog header="Finalizar Credenciamento" :visible.sync="showCadastro" :style="{ width: '70vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true" :closable="false">
      <div id="topo" class="container scrolable-dialog">
        <error-list :erros="erros" v-if="erros" />

        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p>Para finalizar o cadastro, é necessário informar abaixo a relação de Sócio(s) da Empresa.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-2">
            Caso não encontre o Sócio na pesquisa, realize o cadastro pelo botão +.
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="pessoa">Sócio: *</label>
            <span class="p-fluid">
              <AutoComplete id="pessoa" v-model="selectedPessoa" :dropdown="true" :suggestions="filteredPessoa"
                field="detail" placeholder="Pesquisar" @complete="searchPessoa($event)">
                <template #item="slotProps">
                  <div class="p-fluid" style="max-width: 50vw; text-align: left;">
                    {{ slotProps.item.detail }}
                  </div>
                </template>
              </AutoComplete>
            </span>
          </div>
          <div class="mb-2" style="padding-top: 7px;">
            <br />
            <Button @click="novoSocio()" type="button" title="Novo Sócio" class="p-button-primary mr-2 p-button-success"
              icon="pi pi-plus" />

          </div>
        </div>
        <div class="container">
          <div class="row">
            <div>
              <Button @click="adicionarListagem()" href="#topo" type="button" label="Adicionar"
                class="p-button-primary mr-2 p-button-success" icon="pi pi-check" />
              <Button @click="showCadastro = false" type="button" label="Fechar"
                class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" v-if="listContrVinculo.length === 0" />
            </div>
          </div>
        </div>

        <div v-if="listContrVinculo.length > 0">
          <hr />
        </div>

        <div class="row pr-3 pl-3" v-if="listContrVinculo.length > 0">
          <DataTable :value="listContrVinculo" :paginator="true" :rows="4" class="p-datatable-responsive" :key="0"
            :autoLayout="true" style="min-width: 100%" :rowClass="rowClass">
            <Column headerStyle="width: 1%">
              <template #body="slotProps">
                <div :class="lineClass(slotProps.data)">
                  <Button @click="removerItem(slotProps.data)" type="button" label=""
                    class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
                </div>
              </template>
            </Column>
            <Column headerStyle="width: 40%" field="id" header="Sócio">
              <template #body="slotProps">
                <div :class="lineClass(slotProps.data)">
                  {{ slotProps.data.detail }}
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <div class="container" v-if="listContrVinculo.length > 0">
        <hr />
        <div class="row">
          <div>
            <Button @click="gravar()" href="#topo" type="button" label="Finalizar Credenciamento"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          </div>

          <div>
            <Button @click="showCadastro = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import ContribuinteVinculo from "../models/tributario/ContribuinteVinculo";
import PessoaService from "../services/acesso/pessoa.service";
import DnsClienteService from "../services/nfse/dns.cliente.service";
import PessoaCadastro from "../views/PessoaCadastro.vue";

export default {
  name: "ContribuinteVinculoCadastro",
  components: {
    PessoaCadastro
  },
  data() {
    return {
      loading: false,
      filtro: "",
      tipoTomador: null,
      idCliente: null,
      erros: [],
      showCadastro: false,
      contrVinculo: new ContribuinteVinculo(),
      listContrVinculo: [],
      filteredPessoa: null,
      selectedPessoa: null,
      showOrientacoes: false,
      idConta: null
    }
  },

  created() {
    setTimeout(async () => {
      this.processando(true);
      let host = window.location.hostname;
      this.dnsCliente = await DnsClienteService.get(host);
      if (
        this.dnsCliente &&
        this.dnsCliente.data &&
        this.dnsCliente.data.idCliente
      ) {
        this.idCliente = this.dnsCliente.data.idCliente;
      }
    }, 250);

    this.selectedPessoa = this.contrVinculo.idPessoa;

    this.$root.$on("contribuinteVinculo:novo", () => {
      this.novo();
    });
  },

  methods: {
    rowClass() {
      return null;
    },
    lineClass() {
      return null;
    },
    novo() {
      this.showCadastro = true;
      this.erros = [];
      this.contrVinculo.idPessoa = this.dnsCliente.data.idCliente;
      this.selectedPessoa = null;
      this.listContrVinculo = [];
    },
    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoa = await PessoaService.findAllByClienteFiltro(
          this.dnsCliente.data.idCliente,
          event.query,
          'C'
        )
      }, 250);
    },
    gravar() {
      this.processando(true);

      if (!this.listContrVinculo || this.listContrVinculo.length === 0) {
        this.$root.$emit(
          "alert:warn",
          "Selecione ao menos uma Pessoa para realizar a Declaração!"
        );
        this.processando(false);
      } else {
        this.$parent.solicitacaoCadastro.addSocioVinculo = this.listContrVinculo;
        this.$parent.solicitarCredenciamento(false);
      }
    },
    adicionarListagem() {
      this.processando(true);
      this.erros.splice(0, this.erros.length);
      if (!this.selectedPessoa) {
        this.erros.push("Informe um Sócio!");
      }
      if (this.erros.length === 0) {
        let item = this.listContrVinculo.find(
          (item) => item.id === this.selectedPessoa.id
        );
        if (!item) {
          this.carregarDados(
            this.selectedPessoa,
          );
          this.selectedPessoa = null;
        } else {
          this.$root.$emit(
            "alert:warn",
            "Pessoa já adicionada nesta declaração!"
          );
        }
      }
      this.processando(false);
    },
    removerItem(data) {
      this.processando(true);
      this.listContrVinculo.splice(this.listContrVinculo.indexOf(data), 1);
      this.processando(false);
    },
    novoSocio() {
      this.$root.$emit("pessoaCadastro:novo", this.idCliente);
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    carregarDadosImportados(pessoas) {
      pessoas.map((pessoa) => {
        this.carregarDados(pessoa);
      });
    },
    carregarDados(pessoa) {
      const novoItem = {
        id: pessoa.id,
        idPessoa: pessoa,
        detail: pessoa.detail
      };
      this.listContrVinculo.push(novoItem);
    }
  },
}
</script>


<style scoped>
.scrolable-dialog {
  text-align: left;
  padding-right: 25px;
  width: 60vw;

  overflow-y: inherit;
  overflow-x: inherit;
}

.p-inputtext:disabled {
  color: #a6a6a6;
  border-color: #a6a6a6;
}

textarea {
  width: 100%;
  border-radius: 12px;
}

.mensagem-cancelamento {
  color: black;
  font-weight: bold;
}
</style>